// Mock data for FP Estudio Jurídico

export const studioInfo = {
  name: "FP Estudio Jurídico",
  phone: "2236661214",
  whatsapp: "2236661214",
  email: "info@fpestudio.com.ar",
  tagline: "Experiencia, Profesionalismo y Compromiso Legal",
  description: "Estudio jurídico especializado en derecho penal, sucesiones y aduanero. Brindamos asesoramiento legal integral con un enfoque estratégico y profesional."
};

export const practiceAreas = [
  {
    id: 1,
    title: "Derecho Penal",
    icon: "Scale",
    description: "Especialización en defensa penal. Representación en todas las etapas del proceso judicial, desde la investigación preliminar hasta juicios orales.",
    featured: true,
    services: [
      "Defensa en causas penales",
      "Excarcelaciones y morigeraciones",
      "Juicios orales",
      "Recursos y apelaciones",
      "Asesoramiento preventivo"
    ]
  },
  {
    id: 2,
    title: "Sucesiones",
    icon: "FileText",
    description: "Asesoramiento integral en procesos sucesorios. Tramitación de declaratorias de herederos y división de herencias.",
    services: [
      "Declaratoria de herederos",
      "Testamentos",
      "División de herencias",
      "Particiones judiciales",
      "Legados y donaciones"
    ]
  },
  {
    id: 3,
    title: "Derecho Aduanero",
    icon: "Ship",
    description: "Asistencia legal en operaciones de comercio exterior. Defensa en causas aduaneras y controversias con la administración.",
    services: [
      "Infracciones aduaneras",
      "Contrabando y defensa",
      "Recursos administrativos",
      "Operaciones de importación/exportación",
      "Consultoría aduanera"
    ]
  }
];

export const faqs = [
  {
    id: 1,
    question: "¿En qué se especializa FP Estudio Jurídico?",
    answer: "Nos especializamos en tres áreas principales del derecho: Derecho Penal (nuestra principal especialización), Sucesiones y Derecho Aduanero. Contamos con amplia experiencia en cada una de estas ramas del derecho."
  },
  {
    id: 2,
    question: "¿Cómo puedo agendar una consulta?",
    answer: "Puede contactarnos telefónicamente al 223 6661214, por email a info@fpestudio.com.ar, o completando el formulario de contacto en esta página. Responderemos a la brevedad para coordinar una reunión."
  },
  {
    id: 3,
    question: "¿Qué documentación necesito para la primera consulta?",
    answer: "Dependiendo de su caso, le recomendamos traer toda la documentación relevante: citaciones judiciales, notificaciones, contratos, o cualquier documento relacionado con su situación legal. En la comunicación inicial le indicaremos qué documentos son necesarios."
  },
  {
    id: 4,
    question: "¿Atienden casos en todo el país?",
    answer: "Sí, atendemos casos a nivel nacional en las áreas de nuestra especialización. Para causas penales, sucesiones y aduanero, brindamos asesoramiento y representación en todo el territorio argentino."
  },
  {
    id: 5,
    question: "¿Cuánto tiempo lleva un proceso judicial?",
    answer: "La duración varía según el tipo de caso, la jurisdicción y la complejidad del asunto. En la consulta inicial evaluaremos su situación específica y le brindaremos una estimación realista de los tiempos procesales involucrados."
  },
  {
    id: 6,
    question: "¿Ofrecen asesoramiento preventivo?",
    answer: "Sí, además de la defensa judicial, ofrecemos asesoramiento preventivo para evitar conflictos legales. La consulta preventiva es una herramienta valiosa para proteger sus derechos e intereses."
  }
];

export const aboutInfo = {
  title: "Sobre Nosotros",
  description: "FP Estudio Jurídico es un estudio especializado en brindar soluciones legales efectivas en las áreas de derecho penal, sucesiones y aduanero.",
  mission: "Nuestra misión es ofrecer un servicio legal de excelencia, caracterizado por la responsabilidad, el profesionalismo y el compromiso con nuestros clientes. Trabajamos con dedicación para proteger los derechos e intereses de quienes confían en nosotros.",
  values: [
    {
      title: "Profesionalismo",
      description: "Abordamos cada caso con rigor técnico y ética profesional."
    },
    {
      title: "Experiencia",
      description: "Contamos con sólida trayectoria en nuestras áreas de especialización."
    },
    {
      title: "Compromiso",
      description: "Nos dedicamos plenamente a la defensa de los intereses de nuestros clientes."
    },
    {
      title: "Confidencialidad",
      description: "Garantizamos la privacidad absoluta de la información confiada."
    }
  ]
};

export const images = {
  hero: "https://images.unsplash.com/photo-1687289133469-b2a07a13b78b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxjb3VydHJvb20lMjBwcmlzb24lMjBiYXJzJTIwanVzdGljZXxlbnwwfHx8fDE3NzI0MDQ5MjR8MA&ixlib=rb-4.1.0&q=85",
  office: "https://images.unsplash.com/photo-1497366754035-f200968a6e72",
  justice: "https://images.unsplash.com/photo-1768839719921-6a554fb3e847",
  ladyJustice: "https://images.unsplash.com/photo-1589994965851-a8f479c573a9",
  contract: "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d",
  lawyer: "https://images.unsplash.com/photo-1658249682487-882436e01650"
};
